import { Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { WorkplaceAvatar } from "@src/appV2/redesign/components/WorkplaceAvatar";

import { type StepAction } from "../types";

export interface IntroStepProps {
  facilityName: string;
  facilityPhoto?: string;
  onAction: (action: StepAction) => void;
}

export function IntroStep(props: IntroStepProps) {
  const { facilityName, facilityPhoto, onAction } = props;

  return (
    <>
      <DialogContent>
        <Stack spacing={6} justifyContent="center" flex={1}>
          <WorkplaceAvatar pictureUrl={facilityPhoto} size="large" />
          <Title variant="h3" component="h3">
            Rate {facilityName}
          </Title>
          <Text variant="body1" color="text.secondary">
            Your honest feedback helps other professionals decide where to work — the good and the
            bad.
          </Text>
        </Stack>
      </DialogContent>
      <DialogFooter orientation="vertical">
        <Stack spacing={3} sx={{ width: "100%" }}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              onAction({ type: "START_REVIEW" });
            }}
          >
            Start review
          </Button>
          <TextButton
            sx={{ alignSelf: "center" }}
            onClick={() => {
              onAction({ type: "CLOSE_FLOW" });
            }}
          >
            Skip Review
          </TextButton>
        </Stack>
      </DialogFooter>
    </>
  );
}
